import styled from "styled-components";
import { theme } from "../../../theme";

export const TableFilterContainer = styled.form<{ isFold: boolean }>`
  background-color: white;
  padding: 24px;
  border-radius: 0px 0px 8px 8px;
  display: ${({ isFold }) => (isFold ? "none" : "flex")};
  flex-wrap: nowrap;
`;

export const SearchFormElementContainer = styled.div`
  flex-grow: 1;
  background-color: white;
`;

export const FilterFormElementWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-right: 24px;
`;

export const FilterLabel = styled.span`
  text-align: left;
  margin-right: 16px;

  min-width: 65px;
  color: ${theme.colors.gray1};

  margin-bottom: 8px;
  ${theme.typo.heading.b14};
`;
export const SearchActionContainer = styled.div<{ isFold?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 24px;
  margin-bottom: ${({ isFold }) => (isFold ? "24px" : "0px")};
  width: 100%;
  justify-content: space-between;
  text-align: right;
  height: 64px;

  /* Gray/Gray 6 */

  background: #ffffff;
  /* Line/아래 그림자 */

  box-shadow: ${({ isFold }) =>
    isFold ? "0px" : "inset 0px -1px 0px #dcdcdc"};
  border-radius: ${({ isFold }) => (isFold ? "8px" : "8px 8px 0px 0px")};
`;

export const IconWrapper = styled.div`
  border-radius: 4px;
  box-sizing: border-box;
  padding: 4px;
  display: flex;
  margin-right: 12px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  height: 32px;
  width: 32px;
  border: 1px solid ${theme.colors.gray6};
`;
export const FilterTitle = styled.div`
  ${theme.typo.heading.b18};
`;
